import { render } from "./AdminDeviceTable.vue?vue&type=template&id=53e8dae8&scoped=true"
import script from "./AdminDeviceTable.vue?vue&type=script&lang=js"
export * from "./AdminDeviceTable.vue?vue&type=script&lang=js"

import "./AdminDeviceTable.vue?vue&type=style&index=0&id=53e8dae8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e8dae8"]])

export default __exports__